import { IconSvg, IconSvgProps } from "./icon"

export default function Heart(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m12.006 19.823-7.639-6.827c-4.151-4.097 1.951-11.963 7.639-5.6 5.687-6.363 11.762 1.53 7.638 5.6l-7.638 6.827Z" />
    </IconSvg>
  )
}
